import { makeAutoObservable, runInAction } from "mobx";

import { teamMemberships } from "@/api";
import { MemberModel } from "@/models/MemberModel";
import { TeamModel } from "@/models/TeamModel";

import type { RootStore } from "@/store/RootStore";

type MembersStatus = "init" | "loading" | "loaded";

export class MembersUX {
  private rootStore: RootStore;

  membersStatus: MembersStatus = "init";

  team: TeamModel;

  members: MemberModel[] = [];

  constructor(rootStore: RootStore, team?: TeamModel) {
    this.rootStore = rootStore;
    if (!team) {
      // eslint-disable-next-line no-param-reassign
      team = new TeamModel(this.rootStore, {
        typename: "TeamShort",
        uid: "",
        title: "",
        bio: null,
        permalink: "",
        personal: false,
        kind: "regular",
        avatarUrls: null,
        followersCount: 0,
        unreadMessagesCount: 0,
        membersCount: 0,
        userPermissions: { read: true, write: true, invite: true, billing: true },
      });
    }
    this.team = team;
    makeAutoObservable(this);
  }

  setMembersStatus(status: MembersStatus) {
    this.membersStatus = status;
  }

  get currentUserRole() {
    const username = this.rootStore.auth.currentUser?.username;
    return this.members.find((member) => member.user.username === username)?.role;
  }

  async loadMembers(signal?: AbortSignal) {
    this.setMembersStatus("loading");
    const { memberships } = await teamMemberships(this.team.permalink, { signal });
    if (memberships) {
      runInAction(() => {
        this.members = memberships.map((i) => new MemberModel(i, this.team));
      });
    }
    this.setMembersStatus("loaded");
  }
}
